import { render, staticRenderFns } from "./ForArtistsExpandContent.vue?vue&type=template&id=90da3634&scoped=true&"
import script from "./ForArtistsExpandContent.vue?vue&type=script&lang=js&"
export * from "./ForArtistsExpandContent.vue?vue&type=script&lang=js&"
import style0 from "./ForArtistsExpandContent.vue?vue&type=style&index=0&id=90da3634&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90da3634",
  null
  
)

export default component.exports